import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY } from "./apiRoutes";

interface UseGetPropertiesByCommunityProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
  communityId: string;
}

const getPropertiesByCommunity = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY(communityId)}`);

const useGetPropertiesByCommunity = ({
  queryParams,
  communityId,
}: UseGetPropertiesByCommunityProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["properties", communityId],
    queryFn: () => getPropertiesByCommunity(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPropertiesByCommunity;
